import {
  ApplicationRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  EventEmitter,
  Input,
  OnInit,
  Output
} from "@angular/core";
import {DialogComponent} from "../../dialogs/dialog/dialog.component";
import {VisBosComponent} from '../../../../../visbos.component';

@Component({
  selector: 'vb-generic-button, [vb-generic-button]',
  templateUrl: './generic-button.component.html',
  styleUrls: ['./generic-button.component.css'],
  entryComponents: [DialogComponent]
})
export class GenericButtonComponent implements OnInit {

  @Input()
  confirmQuestion: string = "Sind Sie sicher?";

  @Input()
  confirmTitle: string;

  @Input()
  helpText: string = "";

  @Input()
  disabledText: string;

  @Input()
  size: string = '';

  @Input()
  iconClass: string;

  @Input()
  buttonClass: string = "btn-default";

  @Input()
  type: 'button' | 'submit' | 'reset' = 'button';

  @Input()
  disabled: boolean = false;

  @Input()
  visible: boolean = true;

  @Input()
  confirm: boolean = false;

  @Input()
  danger: boolean = false;

  @Output()
  buttonClicked: EventEmitter<any> = new EventEmitter<any>();

  rootViewRef;

  @Input()
  id: string;

  private modal: DialogComponent;

  constructor(private appRef: ApplicationRef, private componentFactoryResolver: ComponentFactoryResolver) {
    this.rootViewRef = (appRef.components[0].instance as VisBosComponent).rootViewRef;
  }

  ngOnInit() {
  }

  onButtonClick(event?) {
    this.buttonClicked.emit();
  }

  onModalShowClicked() {
    this.createDialog(DialogComponent);
  }

  createDialog(modalComponent: { new(): DialogComponent }): ComponentRef<DialogComponent> {
    this.rootViewRef.clear();

    let dialogComponentFactory =
      this.componentFactoryResolver.resolveComponentFactory(modalComponent);
    let dialogComponentRef = this.rootViewRef.createComponent(dialogComponentFactory);

    this.modal = dialogComponentRef.instance;

    this.modal.confirmQuestion = this.confirmQuestion;
    this.modal.confirmTitle = this.confirmTitle;
    this.modal.helpText = this.helpText;
    this.modal.danger = this.danger;

    dialogComponentRef.changeDetectorRef.detectChanges();

    let confSub = this.modal.confirmClicked.subscribe(() => {
      this.buttonClicked.next();
      this.modal.hide();
    });

    let cancSub = this.modal.cancelClicked.subscribe(() => {
      this.modal.hide();
    });

    this.modal.onClose().subscribe(() => {
      confSub.unsubscribe();
      cancSub.unsubscribe();
      dialogComponentRef.destroy();
    });

    return dialogComponentRef;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/buttons/generic-button/generic-button.component.ts